import { render, staticRenderFns } from "./Grafico.vue?vue&type=template&id=2ae195fc"
import script from "./Grafico.vue?vue&type=script&lang=js"
export * from "./Grafico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae195fc')) {
      api.createRecord('2ae195fc', component.options)
    } else {
      api.reload('2ae195fc', component.options)
    }
    module.hot.accept("./Grafico.vue?vue&type=template&id=2ae195fc", function () {
      api.rerender('2ae195fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/DashboardReportNMV/components/generic/Grafico.vue"
export default component.exports